/**
 * /list-your-venue and /list-your-venue/not-a-fit — the one link Braeden
 * sends a host (venue-search ledger VS1.2). The words live in
 * src/content/list-your-venue.js and src/content/hostRequirements/.
 */

import NotAFit from '../components/ListYourVenue/NotAFit';
import Requirements from '../components/ListYourVenue/Requirements';

export const PageListYourVenue = () => <Requirements />;
export const PageNotAFit = () => <NotAFit />;
